import { useNavigate, useParams } from "react-router-dom";
import VerifySignupForm from "../components/VerifySignupForm";
import useSignup from "../../common/hooks/pages/useSignup";
import { usePopup } from "../../common/contexts/PopupContext";
import { useMutation } from "react-query";
import { setLocalStorage } from "../../common/helpers/browserStorage";
import { useAuth } from "../../common/contexts/AuthContext";

function VerifySignupContainer() {
  const { token } = useParams();

  const { setAccessToken } = useAuth();
  const { toast } = usePopup();

  const { verifySignup } = useSignup();

  const navigate = useNavigate();

  const { mutate, isLoading } = useMutation({
    mutationFn: verifySignup,
    onSuccess: (res) => {
      const { message, accessToken } = res?.data || {};

      setLocalStorage("accessToken", accessToken);
      setAccessToken(accessToken);

      navigate("/organization");

      toast(message, "success");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while verifying!";
      toast(message, "error");
    },
  });

  return (
    <VerifySignupForm
      onSubmit={(data) => {
        const { password } = data;

        const payload = { password };

        mutate({ payload, token });
      }}
      isSubmitting={isLoading}
    />
  );
}

export default VerifySignupContainer;
